module.exports = __webpack_public_path__ + "static/media/tcgdrop-logo.38d1472f.png";